import { render, staticRenderFns } from "./app-header-layout.vue?vue&type=template&id=45c3ff34&"
import script from "./app-header-layout.ts?vue&type=script&lang=ts&"
export * from "./app-header-layout.ts?vue&type=script&lang=ts&"
import style0 from "./app-header-layout.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports